module.exports = __webpack_public_path__ + "img/zhihuigushi@3x.a07dea3c.png";